import axios from 'axios'
import {
  ConnectionTestResult,
  ConnectionTestStatus,
  SaveConnectionTestRequest,
} from './types'

const API_URL = process.env.REACT_APP_API_URL

const BASE = `${API_URL}/connectiontest`

export const CONNECTION_TEST_PING_URL = `${BASE}/ping`

export function fetchConnectionTestStatus() {
  return axios.get<ConnectionTestStatus>(`${BASE}/status`, {
    params: {t: Date.now()},
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    },
  })
}

export function saveConnectionTestResult(payload: SaveConnectionTestRequest) {
  return axios.post<ConnectionTestResult>(`${BASE}/results`, payload)
}

export function fetchConnectionTestHistory(userId: string) {
  return axios.get<ConnectionTestResult[]>(`${BASE}/history/${userId}`)
}

export function requestConnectionTest(userId: string) {
  return axios.post<{ok: boolean}>(`${BASE}/request/${userId}`)
}
